// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ta-workspace-name {
  font-size: 14px;
  /* font-weight: 600; */
  cursor: default;
  padding-left: 6px;
  padding-bottom: 4px;
  padding-top: 4px;
  width: 100%;
  display: inline-flex;
  cursor: pointer;
}
.ta-workspace-reports-span {
  color: black !important;
}
.ta-workspace-name:hover {
  color: rgba(0, 126, 167, 1);
  text-decoration: underline;
  text-decoration-color: rgba(0, 126, 167, 1);
  background-color: #cfeaf8;
}
.ta-folder-name {
  font-size: 14px;

  font-weight: 600;
  cursor: default;
  padding-left: 6px;
  padding-bottom: 4px;
  padding-top: 4px;
  width: 100%;
  display: inline-flex;
  cursor: pointer;
}
.ta-folder-name-left-caret {
  font-size: 16px;

  font-weight: 600;
  cursor: default;
  padding-left: 0px;
  padding-bottom: 4px;
  padding-top: 4px;
  width: 100%;
  display: inline-flex;
  cursor: pointer;
  color: black;
}
.parent-folder {
  margin-left: 0px;
}

.ta-report-name {
  padding-left: 8px;
  padding-top: 2px;
  padding-bottom: 2px;
  font-size: 14px;
}

.ta-report-name:hover {
  color: rgba(0, 126, 167, 1);
  text-decoration: underline;
  text-decoration-color: rgba(0, 126, 167, 1);
  background-color: #cfeaf8;
}

.ta-report-name:hover > svg {
  fill: rgba(0, 126, 167, 1);
  transition: all ease 0.3s;
}

.ta-pbi-icon {
  margin-right: 4px;
}
.rf-folder-icon {
  padding-right: 5px;
  margin-top: 5px;
  fill: black;
}

.ta-folder-icon {
  padding-right: 4px;
  margin-top: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/components/tabsApps/components/style/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,2CAA2C;EAC3C,yBAAyB;AAC3B;AACA;EACE,eAAe;;EAEf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,eAAe;;EAEf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".ta-workspace-name {\n  font-size: 14px;\n  /* font-weight: 600; */\n  cursor: default;\n  padding-left: 6px;\n  padding-bottom: 4px;\n  padding-top: 4px;\n  width: 100%;\n  display: inline-flex;\n  cursor: pointer;\n}\n.ta-workspace-reports-span {\n  color: black !important;\n}\n.ta-workspace-name:hover {\n  color: rgba(0, 126, 167, 1);\n  text-decoration: underline;\n  text-decoration-color: rgba(0, 126, 167, 1);\n  background-color: #cfeaf8;\n}\n.ta-folder-name {\n  font-size: 14px;\n\n  font-weight: 600;\n  cursor: default;\n  padding-left: 6px;\n  padding-bottom: 4px;\n  padding-top: 4px;\n  width: 100%;\n  display: inline-flex;\n  cursor: pointer;\n}\n.ta-folder-name-left-caret {\n  font-size: 16px;\n\n  font-weight: 600;\n  cursor: default;\n  padding-left: 0px;\n  padding-bottom: 4px;\n  padding-top: 4px;\n  width: 100%;\n  display: inline-flex;\n  cursor: pointer;\n  color: black;\n}\n.parent-folder {\n  margin-left: 0px;\n}\n\n.ta-report-name {\n  padding-left: 8px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  font-size: 14px;\n}\n\n.ta-report-name:hover {\n  color: rgba(0, 126, 167, 1);\n  text-decoration: underline;\n  text-decoration-color: rgba(0, 126, 167, 1);\n  background-color: #cfeaf8;\n}\n\n.ta-report-name:hover > svg {\n  fill: rgba(0, 126, 167, 1);\n  transition: all ease 0.3s;\n}\n\n.ta-pbi-icon {\n  margin-right: 4px;\n}\n.rf-folder-icon {\n  padding-right: 5px;\n  margin-top: 5px;\n  fill: black;\n}\n\n.ta-folder-icon {\n  padding-right: 4px;\n  margin-top: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
